// +----------------------------------------------------------------------
// | Desc: api接口管理库
// +----------------------------------------------------------------------
import https from "@/layout/config/https.js";

const $api = {
  // +----------------------------------------------------------------------
  // | Desc: 优选专利查询无需登录
  // +----------------------------------------------------------------------
  //【客户操作】专利列表
  getCGYXZhuanliList: function (data) {
    return https.post("/os/Zhuanli/getList", data);
  },

  //【客户操作】导出专利
  getCGYXZhuanliExcelList: function (data) {
    return https.post("/os/Zhuanli/getExcelList", data);
  },

  //【客户操作】专利详情
  getCGYXDetaild: function (data) {
    return https.post("/os/Zhuanli/getDetailed", data);
  },

  //【客户操作】购物车列表
  getCGGuanzhuList: function (data) {
    return https.post("/os/Car/getList", data);
  },

  //【客户操作】查询购物车
  CGgetMYguanzhuzhuanli: function (data) {
    return https.post("/os/Car/getMYguanzhuzhuanli", data);
  },

  //【客户操作】加入购物车
  CGsetGuanzhu: function (data) {
    return https.post("/os/Car/setGuanzhu", data);
  },

  //【客户操作】移除购物车
  CGquxiaoGuanzhu: function (data) {
    return https.post("/os/Car/quxiaoGuanzhu", data);
  },

  //【客户操作】批量加入购物车
  batchAddToCart: function (data) {
    return https.post("/os/Car/batchAddToCart", data);
  },

  //【客户操作】批量移除购物车
  batchRemoveFromCart: function (data) {
    return https.post("/os/Car/batchRemoveFromCart", data);
  },

  //【客户操作】清空购物车
  batchMoveToCart: function (data) {
    return https.post("/os/Car/batchMoveToCart", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 登录用户
  // +----------------------------------------------------------------------
  //用户登录
  login: function (data) {
    return https.post("/os/login/login", data);
  },

  //修改密码
  rePassword: function (data) {
    return https.post("/os/login/rePassword", data);
  },

  //更新登录
  getNowUserGobal: function (data) {
    return https.post("/os/login/getNowUserGobal", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 短信发送
  // +----------------------------------------------------------------------
  //注册账号短信
  sendVerifySmsZhuce: function (data) {
    return https.post("/api/Sendsms/sendVerifySmsZhuce", data);
  },

  //重置密码短信
  sendVerifySmsForget: function (data) {
    return https.post("/api/Sendsms/sendVerifySmsForget", data);
  },

  // +----------------------------------------------------------------------
  // | Desc: 注册改密
  // +----------------------------------------------------------------------
  //注册账号
  resigister: function (data) {
    return https.post("/api/Account/resigister", data);
  },

  //重置密码
  resetPassword: function (data) {
    return https.post("/api/Account/resetPassword", data);
  },
};
export default $api;
